import * as React from 'react';
import {FormControl, TableRow,Box, TableBody, Table, TableHead, TableCell, TableContainer, FormHelperText} from '@mui/material';

const Formula = (props: any) => {
    let { label, description, value, error, visible } = props;
    let showDescription = description !== undefined && description !== "";
    
    let showError = error !== undefined && error !== "" && value !== "" ;
    return (
        <Box sx={{ display: visible ? 'block' : 'none' }}>
            <FormControl className="form-control" fullWidth={true}>
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell align="right">
                                </TableCell>
                                <TableCell className="cell-label" align="right">{label}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell width={"50%"} align="right"></TableCell>
                                <TableCell className="cell-value" width={"50%"} align="right">
                                    {value}
                                </TableCell>
                            </TableRow>
                            <TableRow hidden={!showDescription}>
                                <TableCell className="cell-description" width={"100%"} align="right" colSpan={2}>{description}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
                <FormHelperText error={showError}>
                    {showError ? error : null}
                </FormHelperText>
            </FormControl>
        </Box>
    );
}

export default Formula;
